export default __webpack_public_path__ + "static/media/postacie.7a42429d.png";